import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion } from 'motion/react';
import { useEffect, useRef, useState } from 'react';

const Dropdown = ({ options, label, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const menuRef = useRef();

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!menuRef.current.contains(event.target)) {
        if (!isOpen) return;
        setIsOpen(false);
      }
    };

    window.addEventListener('mousedown', handleOutsideClick);

    return () => {
      window.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, setIsOpen]);

  const menuVariants = {
    initial: { opacity: 0, y: -16, scale: 0.9 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: -16, scale: 0.9 },
    transition: { ease: 'easeOut', duration: 0.1 },
  };

  return (
    <div
      className="relative"
      ref={menuRef}
      // onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}
    >
      <button
        className={`px-4 h-11 font-semibold flex items-center justify-between text-sm rounded-xl gap-1 mt-1 bg-none border-2 border-border w-full ${
          selectedOption ? 'text-foreground' : 'text-textGray'
        }`}
        onClick={handleClick}
      >
        {selectedOption ? selectedOption.label : label}
        {isOpen ? (
          <ChevronUp
            color="#9a9a9a"
            strokeWidth={3}
            size={12}
            direction={isOpen ? 'up' : 'down'}
          />
        ) : (
          <ChevronDown color="#9a9a9a" strokeWidth={3} size={12} />
        )}
      </button>
      {isOpen && (
        <motion.div
          className="absolute top-[3.2rem] flex flex-col bg-background border-border border-2 rounded-xl w-full shadow-light z-20"
          initial="initial"
          animate="animate"
          exit="exit"
          variants={menuVariants}
          transition={menuVariants.transition}
        >
          <div className="p-0.5">
            {options.map((option, index) => (
              <button
                // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                key={index}
                className="px-2 py-1.5 text-sm flex flex-row items-center w-full justify-start gap-1.5 rounded-lg hover:bg-muted cursor-pointer font-medium"
                onClick={() => handleOptionSelect(option)}
              >
                <span className="flex flex-row items-center">
                  {option.label}
                </span>
              </button>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Dropdown;
